import './App.css';
import Footer from './components/footer/footer';
import RRDNavbar from './components/navbar/navbar';
import PrivacyPolicy from './components/privacy/privacy';
import Page404 from './components/shared/404/404';
import { HomePage } from './pages/home/home';
import {Routes,Route} from 'react-router-dom';
import JointVenture from './pages/venture/venture';
import AboutUs from './pages/aboutus/aboutus';
import EmiCalculator from './pages/calculator/emi-calc';
import { Project } from './pages/projects/projects';
import { ContactPage } from './components/contact/contact';


function App() {
  return (
    <div>
      <RRDNavbar/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<Project/>}/>
        <Route path="/aboutus" element={<AboutUs/>}/>
        <Route path="/joint-venture" element={<JointVenture/>}/>
        <Route path="/emi-calculator" element={<EmiCalculator/>}/>
        <Route path="/privacy" element={<PrivacyPolicy/>}/>
        <Route path="/contactus" element={<ContactPage/>}/>
        <Route path="*" element={<Page404 />} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
